<template>
  <div class="new-container">
    <div class="new-header-box">
      <div class="user-box"
           style="font-Size:20px">
        <span>您好：
          <a-icon type="user" />{{ name }} {{ sfcoding }}
        </span>
        <span>
          <label v-for="(item, index) in menu"
                 :key="index"
                 @click="menuClick(index)"
                 :class="menuActive == index ? 'active' : ''">{{ item.name }}</label>
          <a-button type="danger"
                    icon="logout"
                    @click="logout">
            退出
          </a-button>
        </span>
      </div>
    </div>
    <div class="container-body">
      <div class="body-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UILayout",
  data () {
    return {
      menu: [
        { name: "招聘列表", url: "/zhaopin" },
        { name: "我的应聘", url: "/yingpin" },
        { name: "我的简历", url: "/jianli" }
      ],
      menuActive: 0,
      name: "张三",
      sfcoding: "（110110********1234）",
      courseList: [8, 16, 24, 32, 40, 48],
      showIndex: 0
    };
  },
  created () {
    this.name = this.$session.get("name");
    this.sfcoding = this.$session.get("sfcoding");
  },
  mounted () {
    // 页面刷新后，导航栏定位对应导航高亮显示
    this.menu.some((item, i) => {
      if (item.url == this.$route.path) {
        let index = this.menu.findIndex(s => s.url == this.$route.path);
        this.menuActive = index;
      }
    });
  },
  methods: {
    menuClick (index) {
      this.menuActive = index;
      this.$message.loading("加载中...");
      this.$router.push(
        index == 2 ? this.menu[index].url + "?btnType=1" : this.menu[index].url
      );
    },
    logout () {
      this.$router.push("/");
      this.$cookie.clearCookie("apryPassport");
      this.$cookie.clearCookie("adminPassport");
    }
  }
};
</script>
<style lang="less" scoped>
@import "./UIlayout.less";
</style>



// WEBPACK FOOTER //
// src/components/ui/UILayout.vue